import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/_services/alert.service';
import { ColDef, Column, ColumnApi, ColumnState, GridApi, GridOptions, GridReadyEvent, ITooltipParams, PaginationChangedEvent, RowClickedEvent } from 'ag-grid-community';
import { environment } from 'src/environments/environment';
const { defaultPageSizeArr, defaultPageSize,adminUser } = environment;
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { Router } from '@angular/router';
import { MerchantService } from '../../merchants/merchant-master/merchant.service';
import { PaymentGatewayService } from '../payment-gateway-service';

@Component({
  selector: 'app-merchant-account',
  templateUrl: './merchant-account.component.html',
  styleUrls: ['./merchant-account.component.scss']
})
export class MerchantAccountComponent implements OnInit {

  
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public rowData: any = [];
  globalSearch: string = '';
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 200,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  collectionSize: number = 0;
  pageRecords: number = defaultPageSize;
  pageSizeArr: any = defaultPageSizeArr;
  pageNumber: number = 1;
  public gridOptions: GridOptions;
  businessType: string = "ALL";

  public columnDefs: ColDef[] = [
    {
      field: 'payId', tooltipField: 'payId', headerName: 'Pay ID', hide: false, cellStyle: { textAlign: 'center' }, headerClass: 'center-header'
    },
    { field: 'businessName', tooltipField: 'businessName', hide: false, headerName: 'Business Name', cellStyle: { textAlign: 'center' }, headerClass: 'center-header' },
    { field: 'emailId', tooltipField: 'emailId', hide: false, headerName: 'Email', cellStyle: { textAlign: 'center' }, headerClass: 'center-header',valueFormatter: params => {
      return params.value ? params.value.replace(/&#x40;/g, '@') : '';
  } },
    { field: 'status', tooltipField: 'status', hide: false, headerName: 'Status', cellStyle: { textAlign: 'center' }, headerClass: 'center-header' },
    { field: 'userType', tooltipField: 'userType', hide: false, headerName: 'User Type', cellStyle: { textAlign: 'center' }, headerClass: 'center-header' },
    { field: 'mobile', tooltipField: 'mobile', hide: false, headerName: 'Mobile', cellStyle: { textAlign: 'center' }, headerClass: 'center-header' },
    { field: 'registrationDate', tooltipField: 'registrationDate', hide: false, headerName: 'Registration Date', cellStyle: { textAlign: 'center' }, headerClass: 'center-header' },
    {
      field: 'actions', headerName: 'Actions', cellRenderer: BtnCellRenderer, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            // console.log("edit clicked", param.data.payId);
            const payId = param.data.payId;
            this.router.navigate(['merchants/edit-account', payId]);
          },
          buttonIconClass: '',
          buttonText: 'Edit',
          buttonClass: 'btn-sm btn-sm-ag-renderer'
        },
      ]
    }
  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide && col.field !== 'actions'))];

  constructor(private alertService: AlertService, private _MS: PaymentGatewayService, private router: Router) {
    this.gridOptions = <GridOptions>{};
  }

  ngOnInit(): void {
    this.getBusinessTypeList();
    // this.router.navigate(['merchants/edit-account'])
  }

  businessTypes: any = [];
  getBusinessTypeList() {
    this._MS.getBusinessTypeList().subscribe(
      {
        next: (data: any) => {
          if (data && data.status === "OK") {
            this.businessTypes = Object.keys(data.payload).map((_: any) => {
              return { key: _, title: data.payload[_] }
            });
          } else {
            this.businessTypes = [];
            this.alertService.toastWarringMessageAlert({
              title: data?.Message || data?.message || data?.respmessage || 'Something went wrong!',
            })
          }
        },
        error: err => {
          this.alertService.toastErrorMessageAlert({
            title: err?.Message || 'Something went wrong!',
          })
        }
      }
    )
  }

  getMerchantAccountList() {
    // let email: any = localStorage.getItem('user');
    let email : any = adminUser;
    this._MS.getMerchantAccountList(this.businessType, email).subscribe(
      {
        next: (data: any) => {
          if (data && data.status === "OK") {
            this.rowData = data.payload;
          } else {
            this.rowData = [];
            this.alertService.toastWarringMessageAlert({
              title: data?.Message || data?.message || data?.respmessage || 'Something went wrong!',
            })
          }
        },
        error: err => {
          this.rowData = [];
          this.alertService.toastErrorMessageAlert({
            title: err?.Message || 'Something went wrong!',
          })
        }
      }
    )
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.showLoadingOverlay();
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    this.getMerchantAccountList();
  }

  onPageSizeChanges(eve: any) {
    this.pageNumber = 1;
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    this.pageNumber = param;
  }

  hideColumn(eve: any, colId: any) {
    if (this.gridColumnApi) {
      this.gridColumnApi.setColumnVisible(colId, eve.target.checked);
    }
  }

  exportAsCsv() {
    if (this.rowData.length) {
      const columnState: ColumnState[] = this.gridColumnApi.getColumnState();
      const columnsToExport = columnState
        .filter(colState => colState.colId !== 'actions')
        .map(colState => colState.colId);
      const exportParams = {
        columnKeys: columnsToExport,
        fileName: 'merchant_account.csv'
      };
      this.gridApi.exportDataAsCsv(exportParams);
    }
  }

  exportAsExcel() {
    if (this.rowData.length) {
      let csfFile: any = this.gridOptions.api?.getDataAsCsv();
      const lines = csfFile.split('\n');
      const result: any[] = [];
      const headers = lines[0].split(',');

      for (let i = 1; i < lines.length; i++) {
        const row = lines[i].split(',');
        if (row.length === headers.length) {
          const obj: any = {};
          for (let j = 0; j < headers.length; j++) {
            obj[JSON.parse(headers[j])] = JSON.parse(row[j]);
          }
          result.push(obj);
        }
      }
      let csvData: any = result;
      // csvData.splice(csvData.length - 1, 1);
      const ws = XLSX.utils.json_to_sheet(csvData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

      const blob = new Blob([wbout], { type: 'application/octet-stream' });
      saveAs(blob, 'merchant_account.xlsx');
    }
  }

  onSearchChange(searchValue: string) {
    this.gridApi.setQuickFilter(searchValue);
  }

}
